import { useEffect, useState } from "react";

const DateInputStart = (props) => {
  const [isPlaceholderVisible, setIsPlaceholderVisible] = useState(true);
  const [trainingDay, setTrainingDay] = useState("Fecha de inicio");

  useEffect(() => {
    if (props.setPlanDate) {
      props.setPlanDate(trainingDay);
    }
  }, [trainingDay]);

  useEffect(() => {
    if (props.defaultDate) {
      setIsPlaceholderVisible(false);
      setTrainingDay(new Date(props.defaultDate).toISOString().split("T")[0]);
    }
  }, [props?.defaultDate]);

  return (
    <input
      id="date-start-user"
      required
      className={`input-style-elevva py-2  ${
        props?.size === "small" ? "dashboard-input" : "dashboard-input-large"
      } w-100`}
      style={{
        color: "#9DACBD",
      }}
      min={props?.minDate || ""}
      name="date-start-user"
      type={isPlaceholderVisible ? "text" : "date"} // ✅ Cambiamos a tipo texto
      placeholder={props?.placeholderInput || "Fecha de inicio"}
      value={
        isPlaceholderVisible
          ? props?.placeholderInput || "Fecha de inicio"
          : trainingDay
      } // ✅ Mostramos el texto como valor
      onFocus={() => {
        if (isPlaceholderVisible) {
          setIsPlaceholderVisible(false);
        }
      }}
      onBlur={() => {
        if (!trainingDay) {
          setTrainingDay("Fecha de inicio"); // Restauramos el texto si está vacío
          setIsPlaceholderVisible(true);
        }
      }}
      onChange={(e) => setTrainingDay(e.target.value)}
      disabled={props?.disabled}
    />
  );
};

export default DateInputStart;
